module.exports = __webpack_public_path__ + "static/media/preview_private_course_C.41d70c64.png";